<button
    mat-icon-button
    [matMenuTriggerFor]="userActions"
    matTooltip="Nutzerprofil öffnen"
    [matTooltipShowDelay]="500">
    <mat-icon class="relative" svgIcon="mat_outline:account_circle" />
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <div class="flex select-text flex-col px-4 py-2 leading-none">
        <span class="mt-1.5 font-medium text-gray-500">{{ user()?.displayName }}</span>
    </div>
    <mat-divider class="my-2" />
    @if (!isExtension()) {
        <a mat-menu-item routerLink="../user-profile">
            <mat-icon svgIcon="mat_outline:manage_accounts" />
            <span>Nutzerprofil</span>
        </a>
    }
    <button mat-menu-item (click)="signOut()">
        <mat-icon svgIcon="mat_outline:logout" />
        <span>Abmelden</span>
    </button>
</mat-menu>
